import React from 'react'
import Day from './day'


const WeekHeader = () => {
    return (
        <div className='text-muted' style={{ display: 'flex', justifyContent: 'space-between'}}>
            <Day>S</Day>
            <Day>M</Day>
            <Day>T</Day>
            <Day>W</Day>
            <Day>T</Day>
            <Day>F</Day>
            <Day>S</Day>
        </div>
    )
}

export default WeekHeader